import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

// Figma "icons / brand" pill and capsule.
export const Capsule = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      d="M4.73565 2.3533C3.15991 2.3533 1.88253 3.63069 1.88253 5.20642C1.88253 6.78216 3.15991 8.05955 4.73565 8.05955C6.31138 8.05955 7.58877 6.78216 7.58877 5.20642C7.58877 3.63069 6.31138 2.3533 4.73565 2.3533ZM1.12923 5.20642C1.12923 3.21465 2.74388 1.6 4.73565 1.6C6.72742 1.6 8.34207 3.21465 8.34207 5.20642C8.34207 7.1982 6.72742 8.81285 4.73565 8.81285C2.74388 8.81285 1.12923 7.1982 1.12923 5.20642Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
    <path
      d="M6.15145 3.47444C6.31233 3.60631 6.33585 3.84363 6.20398 4.00451L3.84992 6.87646C3.71805 7.03734 3.48073 7.06086 3.31985 6.92899C3.15897 6.79712 3.13546 6.5598 3.26732 6.39892L5.62139 3.52697C5.75325 3.36609 5.99057 3.34257 6.15145 3.47444Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
    <path
      d="M10.3479 6.19495L10.3477 6.19512L7.27803 10.3006C6.58452 11.2253 6.77469 12.5338 7.70176 13.2291C8.62632 13.9225 9.93459 13.7324 10.63 12.8057L10.6302 12.8053L13.699 8.70109L13.6993 8.70072C14.395 7.76459 14.2012 6.45719 13.2779 5.77264L13.2762 5.7714C12.3516 5.07794 11.0432 5.26803 10.3479 6.19495ZM13.7273 5.16812C12.4675 4.22395 10.688 4.48593 9.74509 5.74314L6.67539 9.84863V9.84863C5.7306 11.1085 5.99233 12.8886 7.24978 13.8317C8.50968 14.7766 10.2897 14.5148 11.2329 13.2573L14.3029 9.15138L14.3035 9.15058C15.2456 7.88362 14.9877 6.10324 13.7273 5.16812Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
    <path
      d="M8.20989 7.79635C8.33445 7.62974 8.57048 7.59566 8.73708 7.72021L12.6919 10.6769C12.8585 10.8015 12.8926 11.0375 12.768 11.2041C12.6435 11.3707 12.4075 11.4048 12.2408 11.2802L8.28602 8.32354C8.11942 8.19898 8.08533 7.96295 8.20989 7.79635Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);
